import React, { useEffect, useState } from 'react';
import css from './ComingSoonPage.module.css';
import { Button, LayoutSingleColumn, Page } from '../../components';
import ComingSoonSection from '../CustomLandingPage/sections/ComingSoonSection/ComingSoonSection';
// import comingSoon from './coming_soon.png';
// import door from './door.webp';
// import { post } from '../../util/api';

const ComingSoonPage = (props) => {
  // const [showPassForm, setShowPassForm] = useState(false);
  // const [password, setPassword] = useState('');
  return (
    <Page title={'ScanWow'} description={'ScanWow'} scrollingDisabled={false}>
      <LayoutSingleColumn rootClassName={css.pageRoot}>
        <ComingSoonSection />
        {/* {showPassForm ? (
          <div className={css.wrapper}>
            <input
              type="password"
              value={password}
              placeholder={'Type here...'}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  return post('/api/check-mvp-password', { password })
                    .then((resp) => {
                      window.localStorage.setItem('mvpPassword', password);
                      if (typeof window !== 'undefined') window.location.pathname = '/';
                    })
                    .catch((e) => {
                      if (typeof window !== 'undefined') window.location.pathname = '/coming-soon';
                    });
                }
              }}
            ></input>
          </div>
        ) : (
          <>
            <img src={comingSoon} className={css.cover} />
            <img src={door} className={css.door} onClick={() => setShowPassForm(true)} />
          </>
        )} */}
      </LayoutSingleColumn>
    </Page>
  );
};

export default ComingSoonPage;
